import { render } from "./TransactionPosting.vue?vue&type=template&id=f80fd1ee&scoped=true"
import script from "./TransactionPosting.vue?vue&type=script&lang=js"
export * from "./TransactionPosting.vue?vue&type=script&lang=js"

import "./TransactionPosting.vue?vue&type=style&index=0&id=f80fd1ee&scoped=true&lang=css"
import "./TransactionPosting.vue?vue&type=style&index=1&id=f80fd1ee&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f80fd1ee"]])

export default __exports__